import {
  GET_STORES, 
  SET_STORES,
  GET_REMAINING,
  SET_REMAINING,
  GET_CARWASH_TYPE,
  SET_CARWASH_TYPE,
  ADD_CURRENT_BUYING,
  MODIFY_AMOUNT_BUYING
} from '../types/Support';
import { getStores,getRemainingCarwash, getCarwashType } from "../../services/support";

import { forkJoin, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import {routesHardCoded} from '../../utils/routesHardCoded'
export const getStoresData = () => (dispatch) => {
  dispatch({ type: GET_STORES });

  forkJoin({
    stores: getStores(),
    remaining: getRemainingCarwash(),
    carwashType: getCarwashType(),
  })
  .pipe(
    tap(({ stores, remaining, carwashType }) => {
      //SET_REMAINING & SET_CARWASH_TYPE might have use somedays
      dispatch({ type: SET_REMAINING, payload: remaining });
      dispatch({ type: SET_CARWASH_TYPE, payload: carwashType });
     //merge data here
     const merged = stores.stores.map(object => {
        
        const carwashRemainingData = remaining.stores.find(carwash => carwash.id === object.id);
        
        const carwashTypesWithAmounts = carwashType.storeCarwashTypes.map(type => {
          const amountData = carwashRemainingData ? carwashRemainingData[type.nameEn] : null; 
          return {
            ...type,
            amount: amountData // This will be an array or null
          };
        });
  
        return {
          ...object,
          carwashTypes: carwashTypesWithAmounts // Add the carwash types with amounts to the store object
        };
      })
        /*add routes*/
        .map(store => {
          const matched = routesHardCoded.filter(element => element.storeId == store.id).map(route => {

            return {
              ...route
            }
          })

          return {
            ...store,
            routes: matched
          }
        })

        dispatch({ type: SET_STORES, payload: merged });

      
      

    
    }),
    catchError((error) => {
      // Handle error
      console.error('Error fetching data:', error);
      // Re-throw the error to propagate it further
      return throwError(() => new Error(error));
    })
  )
  .subscribe();
};

export const getRemainingCarwashData = () => (dispatch) => {
  dispatch({ type: GET_REMAINING });
  getRemainingCarwash().subscribe({
    next: (value) =>
      dispatch({ type: SET_REMAINING, payload: value })
  });
}

export const getCarwashTypeData = () => (dispatch) => {
  dispatch({ type: GET_CARWASH_TYPE });
  getCarwashType().subscribe({
    next: (value) =>
      dispatch({ type: SET_CARWASH_TYPE, payload: value })
  });
}



export const addToCurrentBuying = (route) => (dispatch) => {
  dispatch({ type: ADD_CURRENT_BUYING, payload: route });
};

export const modifyAmountBuying = (storeId, routeName, newValue) => ({
  type: MODIFY_AMOUNT_BUYING,
  payload: {
    storeId,
    routeName,
    newValue
  }
});